export enum enumOrganizationType {
  SMALL_BUSINESS = 1,
  MEDIUM_BUSINESS = 2,
  ENTERPRISE = 3,
  AGENT = 4,
  INDIVIDUAL = 5,
  OTHER = 6,
}
